<template>
    <div class="no-items-container">
        <slot></slot>
        <label>{{text}}</label>
    </div>
</template>

<script>
export default {
    props:{
        text:{
            type: String,
            default: 'No items to display.'
        }
    }
}
</script>

<style scoped lang='scss'>
.no-items-container {
  margin-top: 10vh;
  height: 15vh;
  color: rgba(90, 166, 216, 0.44);

  label {
    color: rgba(111, 114, 115, 0.82);
    font-size: 22px;
    margin-top: 15px;
  }
}
</style>